// extracted by mini-css-extract-plugin
export var activeDot = "_96-c";
export var buttonContainer = "_96-9";
export var channelButton = "_96-a";
export var clickable = "_96-d";
export var content = "_96-0";
export var contentFull = "_96-2";
export var contentThird = "_96-1";
export var contentWrapper = "_96-7";
export var description = "_96-5";
export var heightShort = "_96-f";
export var image = "_96-3";
export var imageContainer = "_96-4";
export var selectButton = "_96-e";
export var spinnerContainer = "_96-b";
export var titleContent = "_96-8";
export var titleWrapper = "_96-6";